import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'Store/InjectorsTypes';
import { initialState } from 'Slice/BranchSlice';

// First select the relevant part from the state
const selectDomain = (state: RootState) => state?.branchIO || initialState;
export const selectLoading = createSelector([selectDomain], (state) => state.loading);
export const selectData = createSelector([selectDomain], (state) => state.data);
